import { Box, Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getOpenJobs, getSingleOpenJob } from '../../../../Redux/Reducers/JobReducer';

const RecommendedJobs = () => {
    const navigate = useNavigate();
    const jobs = useSelector((state) => state?.jobs?.allJobs)
    const otherJobs = jobs?.open_jobs
    const JobPreferences = useSelector((state) => state?.ProfileArray?.professionaProfile) || [];
    const location = useLocation();
    const dispatch = useDispatch()
    const { id } = useParams();
    const ApplicantsPage = useSelector((state) => state?.jobs?.appliedJobs) || [];
    const appliedJobs = ApplicantsPage?.appliedJobs
    // navigate(`/job-description/${job?.id}`)

    const getRecommendedJobs = () => {
        if (!JobPreferences || !otherJobs?.length) {
            return otherJobs;
        }

        let recommendedJobs = [];

        // Priority 1: Match by preferred_role
        if (JobPreferences?.preferred_role) {
            recommendedJobs = otherJobs?.filter(job =>
                job?.role.toLowerCase() === JobPreferences?.preferred_role.toLowerCase()
            );
        }

        // Priority 2: If less than 10 jobs, add jobs matching preferred_location
        if (recommendedJobs?.length < 10 && JobPreferences?.preferred_location) {
            const locationMatches = otherJobs?.filter(job =>
                !recommendedJobs.includes(job) &&
                job.location?.toLowerCase().includes(JobPreferences?.preferred_location.toLowerCase())
            );
            recommendedJobs = recommendedJobs?.concat(locationMatches);
        }

        // Priority 3: If still less than 10 jobs, add jobs matching preferred_work_mode
        if (recommendedJobs?.length < 10 && JobPreferences?.preferred_work_mode) {
            const workModeMatches = otherJobs?.filter(job =>
                !recommendedJobs.includes(job) &&
                job.work_mode?.toLowerCase() === JobPreferences?.preferred_work_mode.toLowerCase()
            );
            recommendedJobs = recommendedJobs?.concat(workModeMatches);
        }

        // Priority 3: If still less than 10 jobs, add jobs matching preferred_work_mode
        if (recommendedJobs?.length < 10 && JobPreferences?.tag_name) {
            const tagNameMatches = otherJobs?.filter(job =>
                !recommendedJobs.includes(job) &&
                job.mode?.toLowerCase() === JobPreferences?.tag_name.toLowerCase()
            );
            recommendedJobs = recommendedJobs.concat(tagNameMatches);
        }

        // If still less than 10 jobs, add remaining jobs until we reach 10
        if (recommendedJobs?.length < 10) {
            const remainingJobs = otherJobs?.filter(job =>
                !recommendedJobs.includes(job)
            );
            recommendedJobs = recommendedJobs?.concat(remainingJobs);
        }

        // Return first 10 jobs (or all if less than 10)
        return recommendedJobs?.slice(0, 2);
    };

    const recommendedJobsList = getRecommendedJobs();

    // console.log("Recommended Jobs", recommendedJobsList);

    const handleViewAllJobs = async () => {
        navigate('/jobopening');
        await dispatch(getOpenJobs());
    };



    const renderJobLogo = (job) => {
        return job?.company_logo ? (
            <img
                src={job?.company_logo}
                alt={`${job?.company_name} logo`}
                style={{
                    width: '60px',
                    height: '60px',
                    objectFit: 'contain',
                    borderRadius: '4px'
                }}
            />
        ) : (
            <Box
                sx={{
                    width: '60px',
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '4px',
                    color: '#666',
                    fontSize: '16px',
                    fontWeight: 'bold'
                }}
            >
                {job?.company_name?.[0]?.toUpperCase() || 'C'}
            </Box>
        );
    };


    const handleJobClick = (jobId) => {
        const currentId = location?.pathname?.split('/').pop();
        // if (jobId && currentId !== jobId.toString()) {
        dispatch(getSingleOpenJob(jobId));
        navigate(`/job-description/${jobId}`);
        // }s
    };


    return (
        <Box className='sidefeed-box job-openings-box my-2'>
            <div className='sidefeed-titles d-flex justify-content-between align-items-center mb-2'>
                <Typography variant="subtitle1" fontWeight="bold">
                    Jobs For You
                </Typography>
            </div>

            {recommendedJobsList?.length > 0 ? (
                recommendedJobsList?.map((job, index) => (
                    <Box
                        key={index}
                        display="flex"
                        alignItems="center"
                        p={2}
                        mt={1}
                        borderRadius={2}
                        border={"1px solid lightgray"}
                    >
                        {/* Left Section: Logo & Button */}
                        <Box display="flex" flexDirection="column" alignItems="center">
                            {renderJobLogo(job)}
                            <Button
                                variant="text"
                                size="small"
                                onClick={() => handleJobClick(job?.id)}
                                sx={{
                                    mt: "4px",
                                    py: 0.5,
                                    px: 2,
                                    fontSize: "12px",
                                    whiteSpace: "nowrap"  // prevents text from wrapping
                                }}
                            >
                                View Job
                            </Button>

                        </Box>

                        {/* Right Section: Job Details */}
                        <Box ml={2}>
                            <Typography variant="subtitle2" fontWeight="bold" color={"#0044C6"} fontSize={"16px"}>
                                {job?.role || "Position Not Specified"}
                            </Typography>
                            <Typography variant="body2" sx={{ color: "#666" }}>
                                <strong>Company Name :</strong> {job?.company_name || "Company Not Specified"}
                            </Typography>
                            <Typography variant="body2" color="textSecondary" sx={{ color: "#666" }}>
                                <strong>Location :</strong> {job?.location || "Location Not Specified"}
                            </Typography>
                        </Box>
                    </Box>
                ))
            ) : (
                <Box sx={{ textAlign: 'center', p: 3 }}>
                    <Typography variant="body2" color="textSecondary">
                        No Recommended Jobs found
                    </Typography>
                </Box>
            )}

            <Box sx={{ display: 'flex', justifyContent: "space-evenly", mt: 2 }}>
                <Button onClick={handleViewAllJobs}>View All Jobs</Button>
            </Box>
        </Box>
    )
};

export default RecommendedJobs;